module.exports = __webpack_public_path__ + "static/media/fightscout-web.9cdfbf8d.png";